window.LightSignUpAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    /**
     * [GetUserInfo by code]
     * @param code [code query to get user info for non-candite users url?code=]
     * @returns {deferred.promise|{then}|{then, always}}
     */
    self.GetUserInfo = function (code) {
        var deferred = $q.defer();

        _protected.request('light_signup?code=' + encodeURIComponent(code), 'GET')
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * [UpdateUserInfo after he signup as harri new user]
     * @param userInfo [user light information object]
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.UpdateUserInfo = function (userInfo, gRecaptchaResponse) {
        var deferred = $q.defer();

        var data = {
            "first_name": userInfo.first_name,
            "last_name": userInfo.last_name,
            "password":userInfo.password,
            "code" : userInfo.code,
            "g-recaptcha-response": gRecaptchaResponse
        }

        _protected.request('light_signup', 'POST', data)
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.resendVerificationEmail = function (payload) {
        var deferred = $q.defer();

        _protected.request('public/users/light_signup/resend', 'POST', payload)
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };
});